const getLanguageCode = language => language.substring(0, 2);

module.exports = { getLanguageCode };
